export default __webpack_public_path__ + "static/hero-background-bd70a38468171aefd91b393c9b6b23d9.png";